import { DeleteIcon } from '../../Icons'
import '../index.css'

interface RemoveChipProps {
  onClick?: () => void
  label?: string
}

const RemoveChip: React.FC<RemoveChipProps> = ({ onClick, label }) => {

  return (
    <div>
      <button className="chip-btn" onClick={onClick}>
        <DeleteIcon className="chip-btn__icon" />
        {label}
      </button>
    </div>
  )
}

export default RemoveChip